import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  column-gap: 50px;

  & > ol {
    flex: 0 1 410px;
  }

  & > div:last-child {
    flex: 0 1 390px;
  }

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    row-gap: 30px;

    & > div:last-child {
      flex-basis: auto;
    }
  }
`

export const Description = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  & > p {
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: 767px) {
    margin: 0;
  }
`
